import './scss/4col-image-layout.scss';
import './scss/4col-image-layout-desktop.scss';
import 'swiper/swiper-bundle.css';
import Swiper from 'swiper/bundle';

export default class Mobile4ColumnSwiper {

    constructor(el) {
        this.el = el;
        this.selectors = {
            init: false
        }
        this.init();
    }
   
    initCarousel() {
        const self = this;
        const myCustomSlider = self.el.querySelector('.col4-container');
        const slideCount = myCustomSlider.querySelectorAll(".swiper-slide").length;
        const mobile = window.matchMedia('(min-width: 0px) and (max-width: 620px)');
        const desktop = window.matchMedia('(min-width: 621px)');
        if (mobile.matches) {
            if (!self.selectors.init) {
                self.selectors.init = true;
                 if (!myCustomSlider.swiper) {
                     const swiper = new Swiper(myCustomSlider, {
                                        pagination: {
                                            el: ".swiper-pagination",
                                            clickable: true
                                        },
                                        slidesPerView: 1.3,
                                        spaceBetween: 20,
                                        init: slideCount > 1 ? true : false,
                                    });
                                 }
            }   
        } else if (desktop.matches) {
            if (myCustomSlider.swiper) {
                myCustomSlider.swiper.destroy(true, true);
            } 
            self.selectors.init = false;
        }   
    }

    debounce(func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    init() {
        const self = this; 
        self.initCarousel();   

        let mobileResize = self.debounce(function () {
            self.initCarousel();
        }, 250);


        /* On Resize
        **************************************************************/
        window.addEventListener('resize', mobileResize);
        
    }
    
}
